<ng-template #modalPanoramic let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{modalParams.edit ? 'Ενημέρωση' : 'Προσθήκη'}}</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" style="height: 400px;">
		<p *ngIf="this.modalParams.blob.length === 0" class="m-t-20">
			Μέγιστο μέγεθος αρχείου: 3MB, Τύπος αρχείου: JPG
			<ngx-dropzone accept=".jpg" maxFileSize="3000000" (change)="onSelectPanoramic($event)">
				<ngx-dropzone-label>Σύρετε ή επιλέξτε αρχείο πανοραμικής Φωτογραφίας</ngx-dropzone-label>
			</ngx-dropzone>
		</p>
		<app-panorama-container *ngIf="this.modalParams.blob.length > 0"
								[panoramic]="this.modalParams.blob"
								[haveLabels]="true" [editMode]="false"></app-panorama-container>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-success" (click)="newPanorama()">Ενημέρωση</button>
	</div>
</ng-template>
<div style="position: relative">
	<div class="text-center loaderDiv" *ngIf="flowLoading">
		<label>Ενημέρωση</label>
		<div class="preloader3 loader-block" style="height: 100%;">
			<div class="circ1"></div>
			<div class="circ2"></div>
			<div class="circ3"></div>
			<div class="circ4"></div>
		</div>
	</div>
	<form novalidate>
		<div class="text-right">
			<button type="button" class="btn btn-primary mr-2" (click)="createSite()" *ngIf="!hiddenButtons.addSite">
				Νέος Χώρος
			</button>
			<button type="button" class="btn btn-success mr-2" (click)="saveSite()">Αποθήκευση</button>
			<button type="button" class="btn btn-success mr-2" (click)="saveSite(true)">Αποθήκευση και συνέχεια στην
																						επόμενη Οθόνη
			</button>
			<button type="button" class="btn btn-danger" (click)="deleteSite()">Διαγραφή</button>
		</div>
		<div class="row mt-3">
			<div class="col-md-6">
				<app-translation-tab titleName="Όνομα Χώρου"
									 bindingAttribute="name"
									 [(translationArray)]="site.siteTranslations">
				</app-translation-tab>
			</div>
			<div class="col-md-6" *ngIf="screenNumber===2">
				<app-translation-tab titleName="Λεκτικό Λίστας"
									 bindingAttribute="listName"
									 [(translationArray)]="site.siteTranslations">
				</app-translation-tab>
			</div>
			<div class="col-md-6" *ngIf="screenNumber===2">
				<app-translation-tab titleName="Λεκτικό Αιώνα στις Πανοραμικές"
									 bindingAttribute="century"
									 [(translationArray)]="site.siteTranslations">
				</app-translation-tab>
			</div>
			<div class="col-md-6" *ngIf="screenNumber===2">
				<app-translation-tab titleName="Μικρή περιγραφή"
									 bindingAttribute="shortDescription"
									 [(translationArray)]="site.siteTranslations">
				</app-translation-tab>
			</div>
		</div>
		<div class="m-b-40">
			<div class="btn-group btn-group-toggle mr-4" ngbRadioGroup name="activeSite" [(ngModel)]="site.active"
				 *ngIf="screenNumber===1">
				<label ngbButtonLabel class="btn-primary">
					<input ngbButton type="radio" [value]="true"> Ενεργό
				</label>
				<label ngbButtonLabel class="btn-primary">
					<input ngbButton type="radio" [value]="false"> Ανενεργό
				</label>
			</div>
			<div class="btn-group btn-group-toggle mr-2" ngbRadioGroup name="freeSite" [(ngModel)]="site.free">
				<label ngbButtonLabel class="btn-primary">
					<input ngbButton type="radio" [value]="true"> Δωρεάν
				</label>
				<label ngbButtonLabel class="btn-primary">
					<input ngbButton type="radio" [value]="false"> Επι-πληρωμή
				</label>
			</div>
			<b *ngIf="screenNumber ===1">Η ρύθμιση για την τιμή γίνεται στην οθόνη 2 - με τις λεπτομέρειες του
										 αρχαιολογικού χώρου</b>
		</div>
		<b class="mb-2" [hidden]="hiddenButtons.firstmap">Επιλογή σημείου στον χάρτη μετακινώντας την πινέζα του χώρου.
			<em>Αφού επιλεγεί εδώ αυτόματα θα
				ανανεωθεί και
				στην δεξιά οθόνη του κινητού.</em></b>
		<div class="text-right m-b-10 m-t-10" [hidden]="hiddenButtons.firstmap"><b>Συντεταγμένες:</b> <span id="coords"
																											style="padding: 0 5px;">&nbsp;
        Lat: <input name="latitude" type="number" [(ngModel)]="site.latitude" (change)="changeLatLng()">
        Lng: <input name="longitude" type="number" [(ngModel)]="site.longitude" (change)="changeLatLng()">
        </span></div>
		<div id="map-{{screenNumber}}" class="map" [hidden]="hiddenButtons.firstmap">
		</div>
		<div style="height: 800px;width: 100%; position: relative;" *ngIf="screenNumber ===2">
			<div>
				<div *ngIf="selectedPanorama">
					Επιλεγμένη πανοραμική:
					<input name="isMobile" type="checkbox" (change)="mobileToggling($event)" [(ngModel)]="selectedPanorama.mobile"> Πανοραμική κινητού
				</div>
				<ng-select
						name="selectedPanorama"
						style="width: 300px;display: inline-block"
						[items]="site.panoramaImages"
						*ngIf="site"
						ngDefaultControl
						[clearable]="false"
						bindLabel="name"
						(change)="changePanoramaImage()"
						[(ngModel)]="selectedPanorama">
				</ng-select>
				<button type="button" class="btn btn-success ml-2 btn-sm" (click)="openPanoramicEditModal(false)">ΠΡΟΣΘΗΚΗ</button>
				<button type="button" class="btn btn-danger ml-2 btn-sm" (click)="deletePanoramic()">ΔΙΑΓΡΑΦΗ</button>
			</div>
			<div class="poiSelected" *ngIf="site.panoramaImages.length >0">
				<div>Επιλεγμένο σημείο αναφοράς:</div>
				<ng-select
						name="selectedHotspot"
						style="width: 300px;display: inline-block"
						[items]="selectedPanorama.panoramaHotSpots"
						*ngIf="selectedPanorama"
						[groupBy]="groupByFn"
						ngDefaultControl
						bindLabel="panoramaHotspotsTranslationList.0.name"
						[(ngModel)]="selectedMonument">
				</ng-select>
				<button type="button" class="btn btn-success ml-2 btn-sm" (click)="createHotSpot()">ΠΡΟΣΘΗΚΗ</button>
			</div>
			<ng-container *ngIf="site.panoramaImages.length >0">
				<app-panorama-container
						*ngIf="selectedPanorama"
						[parentId]="site.id"
						[panoramichotspots]="selectedMonument"
						[panoramic]="selectedPanorama.image"
						[haveLabels]="true" [editMode]="true"
						(panoramaConfigurationChange)="updatePanoramaMetaData($event)"
						(pinConfigurationChange)="changePanoramaOfMonument($event)"
						[rotateX]="selectedPanorama.rotateX"
						[showCompass]="true"
						[north_rotateY]="selectedPanorama.northRotateY"
						[rotateY]="selectedPanorama.rotateY"></app-panorama-container>
			</ng-container>
			<ng-container *ngIf="site.panoramaImages.length ===0">
				<div class="text-center" style="display: block; vertical-align: middle; margin-top: 17rem;">
					ΔΕΝ ΥΠΑΡΧΕΙ ΚΑΤΑΧΩΡΗΜΕΝΗ ΠΑΝΟΡΑΜΙΚΗ ΓΙΑ ΤΟΝ ΑΡΧΑΙΟΛΟΓΙΚΟ ΧΩΡΟ
				</div>
			</ng-container>
		</div>
	</form>
</div>